/* import __COLOCATED_TEMPLATE__ from './version.hbs.js'; */
var _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { getOwner } from '@ember/owner';
import Modal from 'vagrant/utils/modal';
import { next } from '@ember/runloop';
let _class = (_class2 = class _class2 extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "api", _descriptor, this);
    _initializerDefineProperty(this, "vagrantContext", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _initializerDefineProperty(this, "router", _descriptor4, this);
    _initializerDefineProperty(this, "flashMessages", _descriptor5, this);
    _initializerDefineProperty(this, "deleteModal", _descriptor6, this);
    _initializerDefineProperty(this, "deleteProviderModal", _descriptor7, this);
    _initializerDefineProperty(this, "deleteArchitectureModal", _descriptor8, this);
    _initializerDefineProperty(this, "editingProvider", _descriptor9, this);
    _initializerDefineProperty(this, "activeProvider", _descriptor0, this);
    _initializerDefineProperty(this, "activeArchitecture", _descriptor1, this);
    _initializerDefineProperty(this, "releaseModal", _descriptor10, this);
    _initializerDefineProperty(this, "revokeModal", _descriptor11, this);
  }
  async download(provider, arch, e) {
    e.preventDefault();
    const registryId = this.vagrantContext.registry?.name;
    const boxId = this.args.box.name;
    const versionId = this.args.version.name;
    if (!registryId || !boxId || !versionId || !provider.name) return;
    const {
      url
    } = await this.api.vagrant.registryServiceApi.downloadBox(registryId, boxId, versionId, provider.name, arch.architectureType ?? '');
    window.open(url);
  }
  editProvider(provider, evt) {
    evt.stopImmediatePropagation();
    this.editingProvider = provider;

    // eslint-disable-next-line ember/no-runloop
    next(() => {
      const inputEl = document.querySelector(`#provider-edit-${provider.name}`);
      if (!inputEl) return;
      inputEl.focus();
    });
  }
  triggerProviderDelete(provider) {
    this.activeProvider = provider;
    this.deleteProviderModal.open();
  }
  async refreshRoute() {
    const route = getOwner(this)?.lookup('route:registries.registry.boxes.box.versions.version');
    await route?.refresh();
  }
  async afterProviderDelete() {
    await this.refreshRoute();
  }
  triggerArchitectureDelete(architecture, provider) {
    this.activeArchitecture = architecture;
    this.activeProvider = provider;
    this.deleteArchitectureModal.open();
  }
  async afterArchitectureDelete() {
    await this.refreshRoute();
  }
  nameChange(ev) {
    if (ev.key === 'Enter') {
      // @ts-expect-error
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      this.changeProviderName.perform(this.editingProvider, ev.target.value);
    } else if (ev.key === 'Escape') {
      this.editingProvider = undefined;
    }
  }
  cancelNameChange() {
    // Pressing escape will clear the provider, then remove the input, which
    // invoked the blur event which, without this guard, would modify editingProvider
    // twice in one tick of the event loop which the glimmer vm does not tolerate.
    // @ts-expect-error
    if (this.editingProvider && !this.changeProviderName.isRunning) this.editingProvider = undefined;
  }
  *changeProviderName(provider, newName) {
    const registryId = this.vagrantContext.registry?.name;
    const boxId = this.args.box.name;
    const versionId = this.args.version.name;
    if (!registryId || !boxId || !versionId || !provider.name) return;
    try {
      yield this.api.vagrant.registryServiceApi.updateProvider(registryId, boxId, versionId, provider.name, {
        name: newName
      });
      this.editingProvider = undefined;
      yield this.refreshRoute();
    } catch (err) {
      let message;
      if (err.json) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        const errJson = yield err.json();
        message = errJson.message;
      }
      this.flashMessages.error(this.intl.t('providers.edit.error.message'), {
        content: message ?? err
      });
      this.editingProvider = undefined;
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "api", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "vagrantContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "router", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "flashMessages", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "deleteModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Modal();
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "deleteProviderModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Modal();
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "deleteArchitectureModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Modal();
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "editingProvider", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "activeProvider", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class2.prototype, "activeArchitecture", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "releaseModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Modal();
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "revokeModal", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new Modal();
  }
}), _applyDecoratedDescriptor(_class2.prototype, "download", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "download"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "editProvider", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "editProvider"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "triggerProviderDelete", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "triggerProviderDelete"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterProviderDelete", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "afterProviderDelete"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "triggerArchitectureDelete", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "triggerArchitectureDelete"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterArchitectureDelete", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "afterArchitectureDelete"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "nameChange", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "nameChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cancelNameChange", [action], Object.getOwnPropertyDescriptor(_class2.prototype, "cancelNameChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "changeProviderName", [task], Object.getOwnPropertyDescriptor(_class2.prototype, "changeProviderName"), _class2.prototype), _class2);
export { _class as default };